export enum TurnstileAction {
    APPLICATION_CREATE = "application_create",
    APPLICATION_MULTIPLE = "application_multiple",
    CONTRACTOR_CONTACT = "contractor_contact",
    FINANCIAL_APPLICATION = "financial_application",
    OUR_OFFER_CONTACT = "our_offer_contact",
    REGISTRATION = "registration",
    REPORTING_CONTENT = "reporting_content"
}
export enum TurnstileAction {
    APPLICATION_CREATE = "application_create",
    APPLICATION_MULTIPLE = "application_multiple",
    CONTRACTOR_CONTACT = "contractor_contact",
    FINANCIAL_APPLICATION = "financial_application",
    OUR_OFFER_CONTACT = "our_offer_contact",
    REGISTRATION = "registration",
    REPORTING_CONTENT = "reporting_content"
}
